riot.tag2('event-button', '<button class="btn btn-default" onclick="{() => { this.opts.event(this.opts.framework)}}"> {this.opts.framework} {this.opts.display} </button>', '', '', function(opts) {
});


// WEBPACK FOOTER //
// ./src/riot/tags/event-button.tag